const features = [
  {
    id: 1,
    icon: 'ri-fire-line',
    title: '实时热度追踪',
    desc: '全天候自动监测全网热点事件，热度算法每分钟更新一次排名，确保您看到的永远是最新最热的八卦爆料内容。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多重信息核实',
    desc: '每条上榜内容均经过编辑团队多维度交叉验证，对比多个独立信源，确保黑料信息的真实性与可靠性。',
  },
  {
    id: 3,
    icon: 'ri-user-voice-line',
    title: '匿名投稿机制',
    desc: '支持完全匿名投稿爆料，个人信息加密存储永不泄露。您的爆料可能成为下一个热搜榜首黑料事件。',
  },
  {
    id: 4,
    icon: 'ri-stack-line',
    title: '七大专题覆盖',
    desc: '涵盖网红翻车、明星恋情、直播内幕、综艺争议、品牌塌房等热门领域，满足不同吃瓜口味和兴趣方向。',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              <i className="ri-star-line"></i> 为什么选我们
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              平台特色
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              四大核心优势，让你吃瓜吃得快、吃得准、吃得爽
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {features.map((feature) => (
              <div
                key={feature.id}
                className="group bg-background-100 rounded-xl p-6 hover:bg-background-200/70 transition-all duration-200 text-center"
              >
                <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center bg-primary-100 rounded-2xl group-hover:bg-primary-200 transition-colors">
                  <i className={`${feature.icon} text-2xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}